<template>
  <div id="bodyContainer" class="page-depot slides slow scroll animated smooth noPreload">
    <!-- Slide 1 (#27) -->
    <section data-name="slide-1" class="slide slide1 about fade-6">
      <div class="content">
        <div class="container">
          <div class="wrap">
            <div class="fix-12-12 fix-phablet-12-12 slide1-content">
              <h2 class="ae-1 fromBlur">设计仓酷</h2>
              <h5 class="ae-2 fromBlur">那些很酷的人，正在宇宙漫步</h5>
              <a class="hero-cta-button ae-3 fromBlur">
                Move
                <span>→</span>
              </a>
            </div>
            <div class="sticker-pad">
              <div class="drag-canvas">
                <div v-for="(drag,index) of drags" v-bind:key="index" class>
                  <img :src="drag" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="background" style="background:#101010;"></div>
    </section>

    <section v-for="(item,index) in depots" v-bind:key="index" :data-name="item.dataName" class="slide slide2 about fade-6">
      <div class="content">
        <div class="container">
          <div class="wrap">
            <div class="fix-12-12 fix-phablet-12-12 slide2-content">
              <h2 class="fromBottom">
                <span>{{item.title}}</span>
                {{item.type}}
              </h2>
              <ul>
                <li v-for="(course,itemIndex) in item.list" v-bind:key="itemIndex" :class="course.cssText" :id="course.popupId" :data-popup-id="course.popupId" @click="onItemClick(index,itemIndex)">
                  <img :src="course.imageUrl" :alt="course.title" />
                  <h3>
                    {{course.nickname}}
                    <br />
                    {{course.title}}
                  </h3>
                  <h5>{{course.date}}</h5>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="background" style="background:#fff;"></div>
    </section>

    <!--Popup -->
    <div v-if="isPopup" :data-popup-id="popupData.popupId" class="popup animated wj">
      <div class="close flex-center">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-popup-close-w" />
        </svg>
      </div>
      <div class="content">
        <div class="container">
          <div class="fix-12-12 fix-phablet-12-12">
            <h1 class="ae-1">
              {{popupData.nickname}}
              <br />
              {{popupData.title}}
            </h1>
            <p class="ae-2">
              <span class="opacity-8">{{popupData.date}}</span>
            </p>
            <div class="popupContent popupWork">
              <div class="selected ae-3">
                <img v-for="(image,index) of popupData.imageUrls" v-bind:key="index" :src="image" alt />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--Popup Video -->
    <div data-popup-id="kc-dt-01" class="popup animated wj">
      <div class="close flex-center">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-popup-close-w" />
        </svg>
      </div>
      <div class="content">
        <div class="container">
          <div class="fix-12-12 fix-phablet-12-12">
            <h1 class="ae-1">
              #AMAO#
              <br />动态插画研究所
            </h1>
            <p class="ae-2">
              <span class="opacity-8">2019.07.04 - 2019.08.01</span>
            </p>
            <div class="popupContent popupWork">
              <div class="selected ae-3">
                <video src="https://video.dinlab.cn/images/admin/website_component/depot/KC-DT-01-video.mp4" controls="controls" loop></video>
                <img src="https://video.dinlab.cn/images/admin/website_component/depot/KC-DT-01-1.jpg" alt />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--Popup Video -->
    <div data-popup-id="kc-amao-02" class="popup animated wj">
      <div class="close flex-center">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-popup-close-w" />
        </svg>
      </div>
      <div class="content">
        <div class="container">
          <div class="fix-12-12 fix-phablet-12-12">
            <h1 class="ae-1">
              #AMAO#
              <br />动态插画研究所 - 第二期
            </h1>
            <p class="ae-2">
              <span class="opacity-8">2019.09.19 - 2019.10.17</span>
            </p>
            <div class="popupContent popupWork">
              <div class="selected ae-3">
                <video src="https://video.dinlab.cn/images/admin/website_component/depot/KC-AMAO-02-1.mp4" controls="controls" loop></video>
                <video src="https://video.dinlab.cn/images/admin/website_component/depot/KC-AMAO-02-2.mp4" controls="controls" loop></video>
                <img src="https://video.dinlab.cn/images/admin/website_component/depot/KC-AMAO-02-3.jpg" alt />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { slidesFunction } from "../utils/slidesTest";
  import { isEmpty } from "../utils/util";

  export default {
    name: "Enterprise",
    data() {
      return {
        timer: false,
        home: '/home',
        drags: [
          'https://video.dinlab.cn/images/admin/website_component/depot/sticker/sticker0.png',
          'https://video.dinlab.cn/images/admin/website_component/depot/sticker/sticker2.png',
          'https://video.dinlab.cn/images/admin/website_component/depot/sticker/sticker3.png',
          'https://video.dinlab.cn/images/admin/website_component/depot/sticker/sticker4.png',
          'https://video.dinlab.cn/images/admin/website_component/depot/sticker/sticker5.png',
          'https://video.dinlab.cn/images/admin/website_component/depot/sticker/sticker6.png',
          'https://video.dinlab.cn/images/admin/website_component/depot/sticker/sticker8.png',
          'https://video.dinlab.cn/images/admin/website_component/depot/sticker/sticker9.png',
          'https://video.dinlab.cn/images/admin/website_component/depot/sticker/sticker12.png'
        ],
        depots: [
          {
            title: '#DinLab#',
            type: '设计课程',
            dataName: 'slide-2',
            list: [
              {
                nickname: '#DinLab X Justill#',
                title: '商业视觉研究所 No.1 下',
                date: '2020.03.08 - 2020.03.22',
                imageUrl: 'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-0.jpg',
                cssText: 'fix-4-12 fix-phablet-4-12 ae-1 fromBottom popupTrigger',
                popupId: 'kc-sy-03',
                popupData: {
                  popupId: 'kc-sy-03',
                  nickname: '#DinLab X Justill#',
                  title: '商业视觉研究所 No.1 下',
                  date: '2020.03.08 - 2020.03.22',
                  imageUrls: [
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-1.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-2.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-3.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-4.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-5.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-6.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-7.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-8.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-9.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-10.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-11.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-12.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-13.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-14.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-15.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-16.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-17.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-18.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-19.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-20.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-21.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-22.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-23.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-24.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-25.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-26.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-27.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-28.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-29.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-30.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-31.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-32.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-33.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-34.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-35.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-36.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-37.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-38.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-39.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-40.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-41.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-42.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-43.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-44.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-45.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-46.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-47.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-48.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-49.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-50.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-51.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-52.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-53.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-54.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-55.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-56.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-57.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-58.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-59.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-60.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-61.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-62.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-63.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-64.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-65.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-66.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-67.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-68.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-69.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-70.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-03-71.jpg'
                  ]
                },
              },
              {
                nickname: '#DinLab X Justill#',
                title: '商业视觉研究所 No.1 上',
                date: '2020.03.08 - 2020.03.22',
                imageUrl: 'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-0.jpg',
                cssText: 'fix-4-12 fix-phablet-4-12 ae-1 fromBottom popupTrigger',
                popupId: 'kc-sy-02',
                popupData: {
                  popupId: 'kc-sy-02',
                  nickname: '#DinLab X Justill#',
                  title: '商业视觉研究所 No.1 上',
                  date: '2020.03.08 - 2020.03.22',
                  imageUrls: [
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-1.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-2.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-3.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-4.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-5.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-6.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-7.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-8.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-9.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-10.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-11.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-12.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-13.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-14.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-15.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-16.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-17.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-18.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-19.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-20.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-21.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-22.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-23.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-24.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-25.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-26.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-27.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-28.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-29.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-30.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-31.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-32.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-33.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-34.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-35.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-36.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-37.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-38.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-39.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-40.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-41.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-42.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-43.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-44.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-45.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-46.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-47.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-48.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-49.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-50.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-51.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-52.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-53.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-54.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-55.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-56.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-57.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-58.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-59.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-60.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-02-61.jpg'
                  ]
                },
              },
              {
                nickname: '#DinLab X Justill#',
                title: '商业视觉研究所 No.1',
                date: '2020.03.08 - 2020.03.22',
                imageUrl: 'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-01-0.jpg',
                cssText: 'fix-4-12 fix-phablet-4-12 ae-1 fromBottom popupTrigger',
                popupId: 'kc-sy-01',
                popupData: {
                  popupId: 'kc-sy-01',
                  nickname: '#DinLab X Justill#',
                  title: '商业视觉研究所 No.1',
                  date: '2020.03.08 - 2020.03.22',
                  imageUrls: [
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-01-1.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-01-2.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-01-3.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-01-4.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-01-5.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-01-6.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-01-7.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-01-8.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-01-9.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-01-10.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-01-11.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-01-12.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-01-13.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-01-14.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-01-15.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-01-16.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-01-17.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-01-18.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-01-19.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-01-20.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-01-21.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-01-22.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-01-23.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-01-24.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-01-25.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-01-26.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SY-01-27.jpg'
                  ]
                },
              },
              {
                nickname: '#DM³｜孙无力#',
                title: '孙无力插画进阶事务所 No.3',
                date: '2020.01.03 - 2020.02.10',
                imageUrl: 'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-03-0.jpg',
                cssText: 'fix-4-12 fix-phablet-4-12 ae-1 fromBottom popupTrigger',
                popupId: 'kc-swl-03',
                popupData: {
                  popupId: 'kc-swl-03',
                  nickname: '#DM³｜孙无力#',
                  title: '孙无力插画进阶事务所 No.3',
                  date: '2020.01.03 - 2020.02.10',
                  imageUrls: [
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-03-1.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-03-2.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-03-3.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-03-4.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-03-5.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-03-6.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-03-7.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-03-8.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-03-9.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-03-10.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-03-11.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-03-12.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-03-13.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-03-14.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-03-15.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-03-16.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-03-17.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-03-18.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-03-19.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-03-20.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-03-21.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-03-22.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-03-23.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-03-24.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-03-25.jpg'
                  ]
                },
              },
              {
                nickname: '#DM³大艺术家#',
                title: '商业插画全能班 No.3',
                date: '2019.12.11 - 2020.01.07',
                imageUrl: 'https://video.dinlab.cn/images/admin/website_component/depot/KC-CH-03-0.jpg',
                cssText: 'fix-4-12 fix-phablet-4-12 ae-1 fromBottom popupTrigger',
                popupId: 'kc-ch-03',
                popupData: {
                  popupId: 'kc-ch-03',
                  nickname: '#DM³大艺术家#',
                  title: '商业插画全能班 No.3',
                  date: '2019.12.11 - 2020.01.07',
                  imageUrls: [
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-CH-03-1.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-CH-03-2.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-CH-03-3.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-CH-03-4.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-CH-03-5.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-CH-03-6.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-CH-03-7.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-CH-03-8.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-CH-03-9.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-CH-03-10.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-CH-03-11.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-CH-03-12.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-CH-03-13.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-CH-03-14.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-CH-03-15.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-CH-03-16.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-CH-03-17.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-CH-03-18.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-CH-03-19.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-CH-03-20.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-CH-03-21.jpg'
                  ]
                },
              },
              {
                nickname: '#AMAO#',
                title: '动态插画研究所 - 第2期',
                date: '2019.09.19 - 2019.10.17',
                imageUrl: 'https://video.dinlab.cn/images/admin/website_component/depot/KC-AMAO-02-0.gif',
                cssText: 'fix-4-12 fix-phablet-4-12 ae-2 fromBottom popupTrigger',
                popupId: 'kc-amao-02',
              },
              {
                nickname: '#無事刊#',
                title: '孙无力插画进阶事务所 No.2',
                date: '2019.10.04 - 2019.11.25',
                imageUrl: 'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-2-0.jpg',
                cssText: 'fix-4-12 fix-phablet-4-12 ae-3 fromBottom popupTrigger',
                popupId: 'kc-swl-02',
                popupData: {
                  popupId: 'kc-swl-02',
                  nickname: '#無事刊#',
                  title: '孙无力插画进阶事务所 No.2',
                  date: '2019.10.04 - 2019.11.25',
                  imageUrls: [
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-02-1.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-02-2.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-02-3.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-02-4.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-02-5.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-02-6.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-02-7.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-02-8.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-02-9.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-02-10.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-02-11.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-02-12.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-02-13.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-02-14.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-02-15.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-02-16.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-02-17.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-02-18.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-02-19.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-02-20.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-02-21.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-02-22.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-02-23.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-02-24.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-02-25.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-02-26.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-02-27.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-02-28.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-02-29.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-02-30.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-02-31.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-02-32.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-02-33.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-02-34.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-02-35.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-02-36.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-02-37.jpg'
                  ]
                },
              },
              {
                nickname: '#一张纸#',
                title: '平面解构教研室',
                date: '2019.10.16 - 2019.11.20',
                imageUrl: 'https://video.dinlab.cn/images/admin/website_component/depot/KC-PM-01-0.jpg',
                cssText: 'fix-4-12 fix-phablet-4-12 ae-2 fromBottom popupTrigger',
                popupId: 'kc-pm-01',
                popupData: {
                  popupId: 'kc-pm-01',
                  nickname: '#一张纸#',
                  title: '平面解构教研室',
                  date: '2019.10.16 - 2019.11.20',
                  imageUrls: [
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-PM-01-1.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-PM-01-2.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-PM-01-3.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-PM-01-4.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-PM-01-5.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-PM-01-6.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-PM-01-7.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-PM-01-8.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-PM-01-9.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-PM-01-10.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-PM-01-11.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-PM-01-12.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-PM-01-13.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-PM-01-14.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-PM-01-15.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-PM-01-16.jpg'
                  ]
                },
              },
              {
                nickname: '#2020 新年#',
                title: '商业插画全能班',
                date: '2019.10.17 - 2019.11.14',
                imageUrl: 'https://video.dinlab.cn/images/admin/website_component/depot/KC-CH-02-0.jpg',
                cssText: 'fix-4-12 fix-phablet-4-12 ae-3 fromBottom popupTrigger',
                popupId: 'kc-ch-02',
                popupData: {
                  popupId: 'kc-ch-02',
                  nickname: '#2020 新年#',
                  title: '商业插画全能班',
                  date: '2019.10.17 - 2019.11.14',
                  imageUrls: [
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-CH-02-1.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-CH-02-2.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-CH-02-3.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-CH-02-4.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-CH-02-5.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-CH-02-6.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-CH-02-7.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-CH-02-8.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-CH-02-9.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-CH-02-10.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-CH-02-11.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-CH-02-12.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-CH-02-13.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-CH-02-14.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-CH-02-15.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-CH-02-16.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-CH-02-17.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-CH-02-18.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-CH-02-19.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-CH-02-20.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-CH-02-21.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-CH-02-22.jpg',
                  ]
                },
              },
              {
                nickname: '#建国70周年#',
                title: '商业插画全能班 Part2',
                date: '2019.08.15 - 2019.09.12',
                imageUrl: 'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-02-0.jpg',
                cssText: 'fix-4-12 fix-phablet-4-12 ae-4 fromBottom popupTrigger',
                popupId: 'kc-hxh-01-02',
                popupData: {
                  popupId: 'kc-hxh-01-02',
                  nickname: '#建国70周年#',
                  title: '商业插画全能班 Part2',
                  date: '2019.08.15 - 2019.09.12',
                  imageUrls: [
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-02-1.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-02-2.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-02-3.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-02-4.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-02-5.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-02-6.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-02-7.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-02-8.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-02-9.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-02-10.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-02-11.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-02-12.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-02-13.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-02-14.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-02-15.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-02-16.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-02-17.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-02-18.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-02-19.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-02-20.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-02-21.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-02-22.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-02-23.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-02-24.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-02-25.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-02-26.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-02-27.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-02-28.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-02-29.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-02-30.jpg',
                  ]
                },
              },
              {
                nickname: '#五灵召唤师#',
                title: '商业插画全能班 Part1',
                date: '2019.08.15 - 2019.09.12',
                imageUrl: 'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-01-0.jpg',
                cssText: 'fix-4-12 fix-phablet-4-12 ae-3 fromBottom popupTrigger',
                popupId: 'kc-hxh-01-01',
                popupData: {
                  popupId: 'kc-hxh-01-01',
                  nickname: '#无力#',
                  title: '商业插画全能班 Part1',
                  date: '2019.08.15 - 2019.09.12',
                  imageUrls: [
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-01-1.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-01-2.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-01-3.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-01-4.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-01-5.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-01-6.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-01-7.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-01-8.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-01-9.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-01-10.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-01-11.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-01-12.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-01-13.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-01-14.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-01-15.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-01-16.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-01-17.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-01-18.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-01-19.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-01-20.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-01-21.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-01-22.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-01-23.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-01-24.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-01-25.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-HXH-01-01-26.jpg',
                  ]
                },
              },
              {
                nickname: '#无力#',
                title: '插画进阶事务所',
                date: '2019.07.20 - 2019.08.17',
                imageUrl: 'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-1-0.jpg',
                cssText: 'fix-4-12 fix-phablet-4-12 ae-4 fromBottom popupTrigger',
                popupId: 'kc-swl-01',
                popupData: {
                  popupId: 'kc-swl-01',
                  nickname: '#无力#',
                  title: '插画进阶事务所',
                  date: '2019.07.20 - 2019.08.17',
                  imageUrls: [
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-1-1.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-1-2.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-1-3.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-1-4.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-1-5.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-1-6.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-1-7.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-1-8.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-1-9.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-1-10.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-1-11.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-1-12.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-1-13.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-1-14.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SWL-1-15.jpg',
                  ]
                },
              },
              {
                nickname: '#AMAO#',
                title: '动态插画研究所',
                date: '2019.07.04 - 2019.08.01',
                imageUrl: 'https://video.dinlab.cn/images/admin/website_component/depot/KC-DT-01-0.jpg',
                cssText: 'fix-4-12 fix-phablet-4-12 ae-5 fromBottom popupTrigger',
                popupId: 'kc-dt-01',
              },
              {
                nickname: '#风绽#',
                title: '噪点插画训练营-第2期',
                date: '2019.06.17 - 2019.07.01',
                imageUrl: 'https://video.dinlab.cn/images/admin/website_component/depot/KC-FZ-02-0.jpg',
                cssText: 'fix-4-12 fix-phablet-4-12 ae-4 fromBottom popupTrigger',
                popupId: 'kc-fz-02',
                popupData: {
                  popupId: 'kc-fz-02',
                  nickname: '#风绽#',
                  title: '噪点插画训练营-第2期',
                  date: '2019.06.17 - 2019.07.01',
                  imageUrls: [
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-FZ-02-1.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-FZ-02-2.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-FZ-02-3.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-FZ-02-4.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-FZ-02-5.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-FZ-02-6.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-FZ-02-7.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-FZ-02-8.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-FZ-02-9.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-FZ-02-10.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-FZ-02-11.jpg',
                  ]
                },
              },
              {
                nickname: '#风绽#',
                title: '噪点插画训练营-第1期',
                date: '2019.05.27 - 2019.06.10',
                imageUrl: 'https://video.dinlab.cn/images/admin/website_component/depot/KC-FZ-01-0.jpg',
                cssText: 'fix-4-12 fix-phablet-4-12 ae-5 fromBottom popupTrigger',
                popupId: 'kc-fz-01',
                popupData: {
                  popupId: 'kc-fz-01',
                  nickname: '#风绽#',
                  title: '噪点插画训练营-第1期',
                  date: '2019.05.27 - 2019.06.10',
                  imageUrls: [
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-FZ-01-1.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-FZ-01-2.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-FZ-01-3.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-FZ-01-4.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-FZ-01-5.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-FZ-01-6.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-FZ-01-7.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-FZ-01-8.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-FZ-01-9.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-FZ-01-10.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-FZ-01-11.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-FZ-01-12.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-FZ-01-13.jpg',
                  ]
                },
              },
              {
                nickname: '#郝小好#',
                title: '商业插画全能班',
                date: '2019.04.24 - 2019.07.03',
                imageUrl: 'https://video.dinlab.cn/images/admin/website_component/depot/KC-SYCH-01-0.jpg',
                cssText: 'fix-4-12 fix-phablet-4-12 ae-6 fromBottom popupTrigger',
                popupId: 'kc-sych-01',
                popupData: {
                  popupId: 'kc-sych-01',
                  nickname: '#郝小好#',
                  title: '商业插画全能班',
                  date: '2019.04.24 - 2019.07.03',
                  imageUrls: [
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SYCH-01-1.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SYCH-01-2.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SYCH-01-3.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SYCH-01-4.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SYCH-01-5.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SYCH-01-6.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SYCH-01-7.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SYCH-01-8.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SYCH-01-9.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-SYCH-01-10.jpg',
                  ]
                },
              },

              {
                nickname: '#梦想小镇#',
                title: 'C4D训练营-第2期',
                date: '2019.06.24 - 2019.07.07',
                imageUrl: 'https://video.dinlab.cn/images/admin/website_component/depot/KC-C4D-02-0.jpg',
                cssText: 'fix-4-12 fix-phablet-4-12 ae-5 fromBottom popupTrigger',
                popupId: 'kc-c4d-02',
                popupData: {
                  popupId: 'kc-c4d-02',
                  nickname: '#梦想小镇#',
                  title: 'C4D训练营-第2期',
                  date: '2019.06.24 - 2019.07.07',
                  imageUrls: [
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-C4D-02-1.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-C4D-02-2.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-C4D-02-3.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-C4D-02-4.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-C4D-02-5.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-C4D-02-6.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-C4D-02-7.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-C4D-02-8.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-C4D-02-9.jpg',
                  ]
                },
              },
              {
                nickname: '#梦想小镇#',
                title: 'C4D训练营-第1期',
                date: '2019.06.03 - 2019.06.16',
                imageUrl: 'https://video.dinlab.cn/images/admin/website_component/depot/KC-C4D-01-0.jpg',
                cssText: 'fix-4-12 fix-phablet-4-12 ae-6 fromBottom popupTrigger',
                popupId: 'kc-c4d-01',
                popupData: {
                  popupId: 'kc-c4d-01',
                  nickname: '#梦想小镇#',
                  title: 'C4D训练营-第1期',
                  date: '2019.06.03 - 2019.06.16',
                  imageUrls: [
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-C4D-01-1.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-C4D-01-2.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-C4D-01-3.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-C4D-01-4.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-C4D-01-5.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-C4D-01-6.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-C4D-01-7.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-C4D-01-8.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-C4D-01-9.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-C4D-01-10.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/KC-C4D-01-11.jpg',
                  ]
                },
              },
            ]
          },
          {
            title: '#坚持的力量#',
            type: '打卡活动',
            dataName: 'slide-3',
            list: [
              {
                nickname: '#DM³大艺术家#',
                title: '插画21天打卡 No.8',
                date: '2020.02.10 - 2020.03.02',
                imageUrl: 'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-08-0.jpg',
                cssText: 'fix-4-12 fix-phablet-4-12 ae-1 fromBottom popupTrigger',
                popupId: 'dk-ch-08',
                popupData: {
                  popupId: 'dk-ch-08',
                  nickname: '#DM³大艺术家#',
                  title: '插画21天打卡 No.8',
                  date: '2020.02.10 - 2020.03.02',
                  imageUrls: [
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-08-1.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-08-2.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-08-3.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-08-4.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-08-5.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-08-6.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-08-7.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-08-8.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-08-9.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-08-10.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-08-11.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-08-12.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-08-13.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-08-14.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-08-15.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-08-16.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-08-17.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-08-18.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-08-19.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-08-20.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-08-21.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-08-22.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-08-23.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-08-24.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-08-25.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-08-26.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-08-27.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-08-28.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-08-29.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-08-30.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-08-31.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-08-32.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-08-33.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-08-34.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-08-35.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-08-36.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-08-37.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-08-38.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-08-39.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-08-40.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-08-41.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-08-42.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-08-43.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-08-44.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-08-45.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-08-46.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-08-47.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-08-48.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-08-49.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-08-50.jpg'
                  ]
                },
              },
              {
                nickname: '#DM³|Color#',
                title: '色彩实验室21天打卡 No.1',
                date: '2019.12.01 - 2019.12.22',
                imageUrl: 'https://video.dinlab.cn/images/admin/website_component/depot/DK-SC-01-0.jpg',
                cssText: 'fix-4-12 fix-phablet-4-12 ae-1 fromBottom popupTrigger',
                popupId: 'dk-sc-01',
                popupData: {
                  popupId: 'dk-sc-01',
                  nickname: '#DM³|Color#',
                  title: '色彩实验室21天打卡 No.1',
                  date: '2019.12.01 - 2019.12.22',
                  imageUrls: [
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-SC-01-1.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-SC-01-2.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-SC-01-3.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-SC-01-4.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-SC-01-5.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-SC-01-6.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-SC-01-7.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-SC-01-8.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-SC-01-9.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-SC-01-10.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-SC-01-11.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-SC-01-12.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-SC-01-13.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-SC-01-14.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-SC-01-15.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-SC-01-16.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-SC-01-17.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-SC-01-18.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-SC-01-19.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-SC-01-20.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-SC-01-21.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-SC-01-22.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-SC-01-23.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-SC-01-24.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-SC-01-25.jpg'
                  ]
                },
              },
              {
                nickname: '#DM³大艺术家#',
                title: '插画21天打卡 No.7',
                date: '2019.12.10 - 2019.12.31',
                imageUrl: 'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-07-0.jpg',
                cssText: 'fix-4-12 fix-phablet-4-12 ae-1 fromBottom popupTrigger',
                popupId: 'dk-ch-07',
                popupData: {
                  popupId: 'dk-ch-07',
                  nickname: '#DM³大艺术家#',
                  title: '插画21天打卡 No.7',
                  date: '2019.12.10 - 2019.12.31',
                  imageUrls: [
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-07-1.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-07-2.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-07-3.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-07-4.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-07-5.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-07-6.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-07-7.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-07-8.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-07-9.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-07-10.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-07-11.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-07-12.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-07-13.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-07-14.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-07-15.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-07-16.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-07-17.jpg'
                  ]
                },
              },
              {
                nickname: '#新神报道#',
                title: '99天海报打卡 第3期Part1',
                date: '2019.08.05 - 2019.11.12',
                imageUrl: 'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-03-0.jpg',
                cssText: 'fix-4-12 fix-phablet-4-12 ae-2 fromBottom popupTrigger',
                popupId: 'dk-hb-03',
                popupData: {
                  popupId: 'dk-hb-03',
                  nickname: '#新神报道#',
                  title: '99天海报打卡 第3期Part1',
                  date: '2019.08.05 - 2019.11.12',
                  imageUrls: [
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-03-1.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-03-2.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-03-3.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-03-4.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-03-5.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-03-6.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-03-7.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-03-8.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-03-9.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-03-10.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-03-11.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-03-12.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-03-13.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-03-14.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-03-15.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-03-16.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-03-17.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-03-18.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-03-19.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-03-20.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-03-21.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-03-22.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-03-23.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-03-24.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-03-25.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-03-26.jpg'
                  ]
                },
              },
              {
                nickname: '#新神报道#',
                title: '99天海报打卡 第2期Part2',
                date: '2019.06.03 - 2019.09.10',
                imageUrl: 'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-02-0.jpg',
                cssText: 'fix-4-12 fix-phablet-4-12 ae-3 fromBottom popupTrigger',
                popupId: 'dk-hb-02',
                popupData: {
                  popupId: 'dk-hb-02',
                  nickname: '#新神报道#',
                  title: '99天海报打卡 第2期Part2',
                  date: '2019.06.03 - 2019.09.10',
                  imageUrls: [
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-02-1.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-02-2.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-02-3.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-02-4.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-02-5.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-02-6.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-02-7.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-02-8.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-02-9.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-02-10.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-02-11.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-02-12.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-02-13.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-02-14.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-02-15.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-02-16.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-02-17.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-02-18.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-02-19.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-02-20.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-02-21.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-02-22.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-02-23.jpg'
                  ]
                },
              },
              {
                nickname: '#诸神之战#',
                title: '99天海报打卡 第1期Part1',
                date: '2019.06.03 - 2019.09.10',
                imageUrl: 'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-01-0.jpg',
                cssText: 'fix-4-12 fix-phablet-4-12 ae-2 fromBottom popupTrigger',
                popupId: 'dk-hb-01',
                popupData: {
                  popupId: 'dk-hb-01',
                  nickname: '#诸神之战#',
                  title: '99天海报打卡 第1期Part1',
                  date: '2019.06.03 - 2019.09.10',
                  imageUrls: [
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-01-1.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-01-2.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-01-3.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-01-4.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-01-5.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-01-6.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-01-7.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-01-8.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-01-9.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-01-10.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-01-11.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-01-12.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-01-13.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-01-14.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-01-15.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-01-16.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-01-17.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-01-18.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-01-19.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-01-20.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-01-21.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-01-22.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-01-23.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-01-24.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-01-25.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-01-26.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-01-27.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-01-28.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-HB-01-29.jpg'
                  ]
                },
              },
              {
                nickname: '#通关不难#',
                title: 'Din插画21天打卡-第2期',
                date: '2019.07.10 - 2019.07.31',
                imageUrl: 'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-02-0.jpg',
                cssText: 'fix-4-12 fix-phablet-4-12 ae-3 fromBottom popupTrigger',
                popupId: 'dk-ch-02',
                popupData: {
                  popupId: 'dk-ch-02',
                  nickname: '#通关不难#',
                  title: 'Din插画21天打卡-第2期',
                  date: '2019.07.10 - 2019.07.31',
                  imageUrls: [
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-02-1.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-02-2.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-02-3.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-02-4.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-02-5.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-02-6.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-02-7.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-02-8.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-02-9.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-02-10.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-02-11.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-02-12.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-02-13.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-02-14.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-02-15.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-02-16.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-02-17.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-02-18.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-02-19.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-02-20.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-02-21.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-02-22.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-02-23.jpg',

                  ]
                }
              },
              {
                nickname: '#坚持的力量#',
                title: 'Din插画21天打卡-第1期',
                date: '2019.06.10 - 2019.07.01',
                imageUrl: 'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-01-0.jpg',
                cssText: 'fix-4-12 fix-phablet-4-12 ae-4 fromBottom popupTrigger',
                popupId: 'dk-ch-01',
                popupData: {
                  popupId: 'dk-ch-01',
                  nickname: '#坚持的力量#',
                  title: 'Din插画21天打卡-第1期',
                  date: '2019.06.10 - 2019.07.01',
                  imageUrls: [
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-01-1.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-01-2.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-01-3.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-01-4.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-01-5.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-01-6.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-01-7.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-01-8.jpg',
                    'https://video.dinlab.cn/images/admin/website_component/depot/DK-CH-01-9.jpg',
                  ]
                }
              }
            ]
          }
        ],
        popupData: null,
        isPopup: false
      }
    },
    created() {
      document.title = '设计仓酷 - Din芝士学院';

      // $(function () {
      //     $('.popupTrigger[data-popup-id="dk-hb-1-1"]').on('click', function () {
      //         window.location.hash = "#dk-hb-1-1";
      //     });
      // });
      // if (window.location.hash === "#dk-hb-1-1") {
      //     setTimeout(function () {
      //         $('.popupTrigger[data-popup-id="dk-hb-1-1"]').click();
      //     }, 500);
      // }
      // $(window).on('popupHidden', function () {
      //     if (history.pushState) {
      //         window.history.pushState("", "", location.href.split('#')[0]);
      //     } else {
      //         window.location.hash = "";
      //     }
      // });

      if (!isEmpty(this.$route.query) && !isEmpty(this.$route.query.id)) {
        let popupId = this.$route.query.id;
        let courseItem = null;
        for (let i = 0; i < this.depots.length; i++) {
          courseItem = this.depots[i].list.find(item => item.popupId == popupId);
          if (!isEmpty(courseItem)) {
            this.isPopup = true;
            this.popupData = courseItem.popupData;
            setTimeout(() => {
              document.getElementById(popupId).click();
            }, 1000)
          }
          return
        }
      }
      // if (!isEmpty(this.$route.query) && !isEmpty(this.$route.query.params)) {
      //     let params = this.$route.query.params.split('-');
      //     let index = params[0];
      //     let itemIndex = params[1];
      //     let depot = this.depots[index];
      //     if (!isEmpty(depot)) {
      //         let courseItem = depot.list[itemIndex];
      //         if (!isEmpty(courseItem) && !isEmpty(courseItem.popupData)) {
      //             this.isPopup = true;
      //             this.popupData = courseItem.popupData;
      //             setTimeout(() => {
      //                 document.getElementById(courseItem.popupId).click();
      //             }, 1000)
      //         }
      //     }
      // }
    },
    mounted() {
      this.onCreateView();
      this.dragSticker();

    },
    methods: {
      onCreateView() {
        document.querySelector('body').classList.add('posr');
        slidesFunction();
        window.scrollTo(0, 1);
        let _this = this
        setTimeout(function () {
          document.querySelector('.drag-canvas').classList.add('dragfast');
        }, 2300);
      },
      dragSticker() {
        !function (a) {
          function f(a, b) {
            if (!(a.originalEvent.touches.length > 1)) {
              a.preventDefault();
              var c = a.originalEvent.changedTouches[0], d = document.createEvent("MouseEvents");
              d.initMouseEvent(b, !0, !0, window, 1, c.screenX, c.screenY, c.clientX, c.clientY, !1, !1, !1, !1, 0, null), a.target.dispatchEvent(d)
            }
          }

          if (a.support.touch = "ontouchend" in document, a.support.touch) {
            var e, b = a.ui.mouse.prototype, c = b._mouseInit, d = b._mouseDestroy;
            b._touchStart = function (a) {
              var b = this;
              !e && b._mouseCapture(a.originalEvent.changedTouches[0]) && (e = !0, b._touchMoved = !1, f(a, "mouseover"), f(a, "mousemove"), f(a, "mousedown"))
            }, b._touchMove = function (a) {
              e && (this._touchMoved = !0, f(a, "mousemove"))
            }, b._touchEnd = function (a) {
              e && (f(a, "mouseup"), f(a, "mouseout"), this._touchMoved || f(a, "click"), e = !1)
            }, b._mouseInit = function () {
              var b = this;
              b.element.bind({
                touchstart: a.proxy(b, "_touchStart"),
                touchmove: a.proxy(b, "_touchMove"),
                touchend: a.proxy(b, "_touchEnd")
              }), c.call(b)
            }, b._mouseDestroy = function () {
              var b = this;
              b.element.unbind({
                touchstart: a.proxy(b, "_touchStart"),
                touchmove: a.proxy(b, "_touchMove"),
                touchend: a.proxy(b, "_touchEnd")
              }), d.call(b)
            }
          }
        }(jQuery);
        $(function () {
          var candidatesH = initCandidates(70);

          $('.drag-canvas > div').each(function () {
            var parentHeight = $(this).parent().height();
            var topPx = Math.floor(Math.random() * (parentHeight - 200));

            var leftPct = findSparsePosition(candidatesH);
            if (leftPct == -1) {
              candidatesH = initCandidates(70);
              leftPct = findSparsePosition(candidatesH);
            }
            // claimValue(candidatesH, leftPct);
            //Garbage collect
            candidatesH = candidatesH.filter(function (i) {
              return i != -1;
            });

            $(this).css({
              'top': topPx + 'px',
              'left': leftPct + '%'
            });
          });
          $(".drag-canvas > div ").draggable({ stack: ".drag-canvas > div" });
          // $(".drag-canvas > div .zoom ").featherlight();

        });

        //Currently assumes sorted sequential array 0-80
        function findSparsePosition(array) {
          var heighest = array[array.length - 1];
          var found = false;
          var returnVal = -2;
          while (array.indexOf(returnVal) == -1 &&
            array.length > 5) {
            returnVal = Math.floor(Math.random() * heighest);
          }

          if (array.indexOf(returnVal) != -1) {
            found = true;
          }

          //If stopped loop because less than 6 options left
          //take first
          if (!found && array.length > 0) {
            returnVal = array[0];
          } else if (!found) { //out of options, start over
            return -1;
          }
          return returnVal;
        }

        // function claimValue(array, val) {
        //   //Check previous and next indices; if adjacent
        //   //to value as well as position let's take them out too
        //   valIndex = array.indexOf(val);
        //   if (valIndex > 0) {
        //     if (array[valIndex - 1] == val - 1) {
        //       array[valIndex - 1] = -1;
        //     }
        //   }
        //   if (valIndex < array.length) {
        //     if (array[valIndex + 1] == val + 1) {
        //       array[valIndex + 1] = -1;
        //     }
        //   }
        //   //Remove our selection from the candidates list
        //   array[valIndex] = -1;
        // }
        function initCandidates(count) {
          var arr = [];
          for (var i = 0; i < count; i++) {
            arr.push(i);
          }
          return arr;
        }
      },
      onItemClick(index, itemIndex) {
        this.isPopup = true;
        this.popupData = this.depots[index].list[itemIndex].popupData
      }
    }
  }
</script>

<style lang="scss">
  .page-depot {
    background: #ffffff;
    padding-bottom: 100px;
    .fade-6 .content {
      background: rgba(0, 0, 0, 0);
    }
    .hero-cta-button {
      font-size: 28px;
      font-family: DINCondensed-Regular;
      color: #ffffff;
      letter-spacing: 1px;
      line-height: 48px;
      position: relative;
      z-index: 2;
      right: auto;
      &:hover {
        color: #fff;
        opacity: 1;
      }
      span {
        display: block;
        position: absolute;
        top: -10px;
        right: -40px;
        transform: rotate(-38deg);
      }
    }

    .hero-cta-button::after {
      content: "";
      position: absolute;
      width: 88px;
      height: 3px;
      bottom: -10px;
      left: 0;
      right: 0;
      background-color: #07d79b;
    }
    .slide1 {
      height: 80vh;
      min-height: 700px;
      position: relative;
      .sticker-pad {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 80vh;
        min-height: 700px;
        z-index: 8;
        .drag-canvas {
          /* position: absolute; */
          top: 0;
          left: 0;
          /* background-color: #000; */
          overflow: hidden;
          height: 80vh;
          min-height: 700px;
          position: relative;
          transition: all 2s ease;
          div {
            position: absolute;
            z-index: 1;
            background-size: cover;
            cursor: move;
            top: 100px;
            left: 100px;
            max-width: 250px;
            height: 250px;
            max-height: inherit;
            display: flex;
            justify-content: flex-end;
            align-items: flex-end;
            padding: 10px;
            font-size: 150%;
            transition: inherit;

            img {
              width: 100%;
            }
            &:hover {
              transform: scale(1.02);
            }
          }
        }
        .dragfast {
          transition: none;
        }
      }

      .slide1-content {
        position: relative;
        margin-top: 14vh;
        z-index: 9;
        height: 100vh;
        /* mix-blend-mode: exclusion; */
        pointer-events: none;
        text-align: left;
        cursor: not-allowed;
        h2 {
          font-weight: 800;
          font-size: 48px;
          color: #ffffff;
          letter-spacing: 4px;
          text-shadow: 0 2px 3px rgba(0, 0, 0, 0.6);
          margin-bottom: 20px;
        }
        h5 {
          max-width: 70%;
          font-weight: 900;
          font-size: 24px;
          color: #ffffff;
          opacity: 0.9;
          letter-spacing: 1.56px;
          line-height: 56px;
          text-shadow: 0 2px 3px rgba(0, 0, 0, 0.6);
          margin-bottom: 12vh;
        }
      }
    }
    .slide2 {
      .slide2-content {
        h2 {
          font-weight: 900;
          font-size: 36px;
          color: #000000;
          letter-spacing: 3px;
          text-align: left;
          margin-bottom: 40px;
          span {
            color: #011fff;
          }
        }
        ul {
          /* display: block; */
          overflow: hidden;
          margin-left: -15px;
          margin-right: -15px;
          li {
            float: left;
            padding: 15px;
            img {
              width: 100%;
            }
            h3 {
              font-weight: 400;
              font-size: 22px;
              line-height: 1.4;
              color: #000000;
              letter-spacing: 1.5px;
              text-align: left;
              margin-top: 10px;
              margin-bottom: 10px;
            }
            h5 {
              font-family: DINCondensed-Regular;
              font-weight: 400;
              font-size: 16px;
              color: #a5a5a5;
              letter-spacing: 1px;
              text-align: left;
              line-height: 2;
            }
          }
        }
        .depot-eye {
          width: 120px;
          margin: 200px auto 100px;
          filter: drop-shadow(0px 4px 6px rgba(0, 0, 0, 0.1));
          img {
            width: 100%;
          }
        }
      }
    }

    .wj {
      .close {
        width: 50px;
        height: 50px;
        background: #000;
        border-radius: 100%;
        text-align: center;
        position: coled;
        top: 30px;
        right: 30px;
        svg {
          width: 18px;
          height: 18px;
        }
      }
      h1 {
        text-align: center;
        margin-top: 100px;
        letter-spacing: 2px;
        font-size: 36px;
      }
      p {
        width: 60%;
        max-width: 640px;
        text-align: center;
        margin: 0 auto;
        line-height: 2;
        opacity: 0.8;
        margin-bottom: 50px;
      }
      .popupWork {
        overflow: hidden;
        margin-bottom: 200px;
        video {
          display: block;
          width: 100%;
          outline: 0;
        }
        img {
          display: block;
        }
      }
    }
  }
  @media screen and (min-width: 1200px) {
    .page-depot {
      min-width: 1100px;
    }
  }
  @media screen and (min-width: 1024px) and (max-width: 1199px) {
    .page-depot {
      min-width: 960px;
      .fix-4-12 {
        width: 285px !important;
      }
    }
  }
  @media screen and (min-width: 768px) and (max-width: 1023px) {
    .page-depot {
      min-width: 700px;
      .fix-4-12 {
        width: 320px !important;
      }
    }
  }
</style>